import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoutes from './route';
import TagManager from 'react-gtm-module';
import './index.css';

const tagManagerArgs = {
  gtmId: 'GTM-WTJW8F4B'
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoutes  />
  </React.StrictMode>
);